import { FunctionComponent, SVGProps } from 'react'

import { ReactComponent as CloseIcon } from 'assets/icons/close16.svg'
import { Button } from 'components/Button'
import Styles from './ToastHeader.module.scss'

export const ToastHeader = ({
  icon: Icon,
  title,
  onClose,
}: {
  icon?: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>>
  title: string
  onClose: () => void
}) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.title}>
        {Icon && <Icon className={Styles.icon} />}

        <div>{title}</div>
      </div>

      <Button variant="tertiary" size="sm" onPress={onClose} endIcon={CloseIcon} />
    </div>
  )
}
